<template>
  <div class="search-result--option">
    <p class="mr-2">Show</p>
    <select
      name="resultsPerPage"
      :value="props.modelValue"
      @input="emit('update:modelValue', $event.target.value)"
    >
      <option :value="10">10</option>
      <option :value="25">25</option>
      <option :value="50">50</option>
    </select>
  </div>
</template>

<script setup>
const props = defineProps(['modelValue'])
const emit = defineEmits(['update:modelValue'])
</script>
